export default [

    {
        path: 'auditorias', component: require('./Read').default,
        meta: {
            middleware: 'auth',
            controller: 'AuditoriaController'
        },
    },

    {
        path: 'relatorios/acessos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/acessos/home',
        meta: { middleware: 'auth', controller: 'RelatorioAcessoController' },
        children: [{
            path: 'home',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcessoController' },
        }, {
            path: 'graficos',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcessoController' },
        }
        ]
    }
];
